import { Component, OnInit } from '@angular/core';
import { PROVINCES } from '../../../data/provinces';
import { Manufacturer } from '../../../../classes/Manufacturer';
import { ActivatedRoute } from '@angular/router';
import { LoginService } from '../../../services/login.service';
import { ModelService } from '../../../services/model.service';
import { GlobalService } from '../../../services/global.service';
import { AlertsService } from '../../../services/alerts.service';
import * as $ from 'jquery';

@Component({
  selector: 'app-edit-manufacturer',
  templateUrl: './edit-manufacturer.component.html',
  styleUrls: ['./edit-manufacturer.component.css']
})
export class EditManufacturerComponent implements OnInit {
    
  provinces = PROVINCES;

  isSubmitButtonDisabled: boolean = false;
  id: number;
  contentVisible: boolean = false;
  editManufacturer: Manufacturer = new Manufacturer( );
  addEmailButtonDisabled: boolean = true;

  hasNotes: boolean = false;
  notes: any;
  isRequiredNotesField: boolean = true;
  isNotesWasEdited: boolean = false;

  availableRoles: string[] = [ 'admin' ];
  isAvailable: boolean = true;

  old_markup: number = 0;

  selectParams: any = {
    billingState: {
      id: 'inputBillingState',
      isRequired: true,
      change: ( event ) => {
        this.editManufacturer.billingState = event.value;
      },
      options: [ { text: '', value: '' } ]
    },
    shippingState: {
      id: 'inputShippingState',
      isRequired: true,
      change: ( event ) => {
        this.editManufacturer.shippingState = event.value;
      },
      options: [ { text: '', value: '' } ]
    }
  };

  constructor ( 
    private route: ActivatedRoute,
    private model: ModelService,
    public global: GlobalService,
    private alerts: AlertsService,
    private loginService: LoginService ) { 
    this.global.setDocumentTitle( 'Edit Manufacturer' );
    if ( this.availableRoles.indexOf( this.loginService.userInfo.role ) === -1 ) this.isAvailable = false;
    else this.isAvailable = true;

    this.provinces.forEach( _state => {
      this.selectParams.billingState.options.push( { text: _state.long, value: _state.short } );
      this.selectParams.shippingState.options.push( { text: _state.long, value: _state.short } );
    });
  }

  ngOnInit ( ) { 
    this.route.params.subscribe(params => {
       this.id = +params['id'];
       this.model.getManufacturerDataByID( this.id, ( manufacturer ) => {
         this.contentVisible = true;
         manufacturer.notes = '';
         this.editManufacturer = manufacturer;
         this.old_markup = this.editManufacturer.markup;
         if ( !this.editManufacturer.emails.length ) this.editManufacturer.emails = [ '' ];
         this.checkEmail( );
         this.editManufacturer.id = this.id;
         this.getNotes( );
       });
    });
  }

  getNotes ( ) {
    this.model.getNotes( 'manufacturer', this.id, ( notes ) => {
      this.notes = notes;
      this.hasNotes = notes.length != 0;
    });
  }

  addNote ( ) {
    this.model.addNote( 'manufacturer', this.id, this.editManufacturer.notes, ( response ) => {
      this.getNotes( );
      this.isRequiredNotesField = false;
      this.isNotesWasEdited = true;
    });
  }

  showHistory ( ) { this.global.changeHPVisibility( true ); }

  trackByIndex( index: number, obj: any ): any {
    return index;
  }


  addEmail ( ) {
    this.editManufacturer.emails.push( '' );
    this.checkEmail( );
  }

  checkEmail ( ) {
    this.addEmailButtonDisabled = ( this.editManufacturer.emails.indexOf( '' ) !== -1 ) ? true : false;
  }

  removeEmail ( _i: number ) {
    this.editManufacturer.emails.splice( _i, 1 );
    this.checkEmail( );
  }


  successCallback ( ) {
    this.global.defaultSuccessMessage({ 
      html: 'Manufacturer information has been updated successfully', 
      redirect: '/manufacturers-list' 
    });
  }


  errorCallback ( message?: string ) {
    let data = {
      messageType: 'error',
      message: message || 'We got some error here...',
      title: ''
    }
    this.alerts.setData( data ).subscribe( );
    this.isSubmitButtonDisabled = false;

  }

  submitForm ( ) {

    this.editManufacturer.memo = $( '#inputMemo' ).html( );

    let _answer;
    let data = {
      message: "Are you sure you want to override markup for every product for this manufacturer?",
      confirmButtonText: "Yes",
      cancelButtonText: "No"
    };

    if ( this.old_markup != this.editManufacturer.markup ) {
      this.global.confirmMessage( data, ( ) => {
        this._submitFormHandler( );
      });
    } else {
      this._submitFormHandler( );
    }

    return false;
  }

  _submitFormHandler ( ) {

    this.isSubmitButtonDisabled = true;
    this.model.editManufacturer( this.editManufacturer, ( response ) => {
      let _answer;
      _answer = response.json( ).answer;
      
      if ( _answer == 'success' ) this.successCallback( );
      else if ( _answer == 'exists' ) {
        this.errorCallback( 'Manufacturer  with name "' + this.editManufacturer.name + '" already exists' );
        this.global.defaultErrorCallback( 'Manufacturer  with name "' + this.editManufacturer.name + '" already exists' );
      } else {
        this.errorCallback( _answer );
        this.global.defaultErrorCallback( _answer );
      }
    });

  }
  
  cancelSubmit ( ) {
    this.global.redirect( '/manufacturers-list' );
  }

}



// WEBPACK FOOTER //
// /root/anvel/angular/app/components/manufacturers/edit-manufacturer/edit-manufacturer.component.ts